import { ArticleCard } from '#/components/ui/ArticleCard';
import { SectionHeader } from '#/components/ui/SectionHeader';
import type { ExploreConceptsView } from '#/content/homepage';

interface ExploreConceptsSectionProps {
  content: ExploreConceptsView;
}

export function ExploreConceptsSection({
  content,
}: ExploreConceptsSectionProps) {
  return (
    <div className="flow flow-inner-20 lg:flow-inner-32">
      <SectionHeader
        title={content.title}
        accentVariant="long"
        contentAlignment="center"
        headingClassName="text-fluid-header tracking-[-0.03em] leading-tight"
      >
        <p className="text-fg-muted">{content.description}</p>
      </SectionHeader>

      <p className="flow-60 text-fluid-subheader text-fg-header text-center font-semibold">
        Explore More Concepts
      </p>

      <div className="grid gap-20 lg:grid-cols-3">
        {content.articles.map((article) => (
          <ArticleCard
            key={article.href}
            title={article.title}
            content={article.summary}
            href={article.href}
            headingLevel="h3"
            dataTrack="home_explore_concept_card"
            dataTrackLabel={article.title}
            dataTrackContext="explore_concepts"
          />
        ))}
      </div>
    </div>
  );
}
